"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultVisitTypeFromConfig = exports.getExtVisitTypeForProvider = exports.getExtIDFromProviderExtID = exports.getExternalIDForProvider = exports.isOSWEnabled = exports.getEpicOSWConfig = void 0;
const Filters_1 = require("./constants/Filters");
const EpicOSW_1 = require("./constants/EpicOSW");
/**
 * Looks for the epic_osw config in the PMCDB config object
 * @param {Object} config The PMCDB config object from CS
 * @returns {Object} The config object that contains the URLs to the host, CSS, JS, etc.
 * @returns {null} If not found
 */
const getEpicOSWConfig = (config) => {
    try {
        return config.third_party_scheduling_configs.epic_osw;
    }
    catch (e) {
        return null;
    }
};
exports.getEpicOSWConfig = getEpicOSWConfig;
/**
 *
 * @param {Object} provider The provider data fetched from the provider endpoint
 * @param {Object} epicOSWConfig The epic_osw object from the PMCDB config in CS
 * @returns {Boolean} true if we find the correct config and provider data, false otherwise
 */
const isOSWEnabled = (provider, epicOSWConfig) => {
    try {
        // external_id for osw clients looks like 1234321@epic_osw
        const [, epicOSWIdentifier] = provider.external_id.split(EpicOSW_1.EXTERNAL_ID_DELIMITER);
        return (epicOSWIdentifier === EpicOSW_1.EXTERNAL_ID_IDENTIFIER && Boolean(epicOSWConfig));
    }
    catch (e) {
        // bad data or missing config, default to normal flow
        return false;
    }
};
exports.isOSWEnabled = isOSWEnabled;
/**
 * This function will find the appropriate Epic OSW external ID to pass to the iFrame
 * for a given provider. It first checks provider.external_systems and falls back to
 * provider.external_id if not found, which is returned by the getExtIDFromProviderExtID
 * function
 * @param {Object} provider The provider data fetched from the provider endpoint
 * @returns {String} The external ID found in provider.external_systems
 * @returns {String} The result from calling getExtIDFromProviderExtID
 */
const getExternalIDForProvider = (provider) => {
    const { external_systems } = provider;
    if (external_systems) {
        try {
            const epicSystemsData = external_systems.find((systemData) => {
                return systemData.system_type === EpicOSW_1.SYSTEM_TYPE_IDENTIFIER;
            });
            if (epicSystemsData) {
                // return the first one we find
                return epicSystemsData.provider_id;
            }
            else {
                // no match
                return (0, exports.getExtIDFromProviderExtID)(provider);
            }
        }
        catch (e) {
            // bad data
            return (0, exports.getExtIDFromProviderExtID)(provider);
        }
    }
    else {
        // no external_systems
        return (0, exports.getExtIDFromProviderExtID)(provider);
    }
};
exports.getExternalIDForProvider = getExternalIDForProvider;
/**
 * This function will find the appropriate Epic OSW external ID to pass to the iFrame
 * for a given provider. It parses provider.external_id and returns what it finds or an
 * empty string. This is the fallback for the getExternalIDForProvider function
 * @param {Object} provider The provider data fetched from the provider endpoint
 * @returns {String} The external ID found in provider.external_id
 * @returns {String} Empty string if no external_id or does not match format
 */
const getExtIDFromProviderExtID = (provider) => {
    const { external_id } = provider;
    if (external_id) {
        // external_id for osw clients looks like 1234321@epic_osw
        try {
            const [externalID, epicOSWIdentifier] = provider.external_id.split(EpicOSW_1.EXTERNAL_ID_DELIMITER);
            if (epicOSWIdentifier === EpicOSW_1.EXTERNAL_ID_IDENTIFIER) {
                return externalID;
            }
            else {
                return '';
            }
        }
        catch (e) {
            // bad data
            return '';
        }
    }
    else {
        // no external_id
        return '';
    }
};
exports.getExtIDFromProviderExtID = getExtIDFromProviderExtID;
/**
 * Finds the appropriate visit type ID to pass to the OSW iFrame (vt param). First checks
 * provider.appointment_ehr_purposes and falls back to the default_visit_type found in the
 * CS config, which is returned by getDefaultVisitTypeFromConfig
 * @param {Object} provider The provider data fetched from the proivder endpoint
 * @param {Object} epicOSWConfig The epic_osw object fetched from the CS config
 * @returns {String} The visit type ID to pass to the OSW iFrame (vt param)
 * @returns {String} The result from calling getDefaultVisitTypeFromConfig if we do not find a result in the ehr_data
 */
const getExtVisitTypeForProvider = (provider, epicOSWConfig) => {
    const { appointment_ehr_purposes } = provider;
    if (appointment_ehr_purposes && appointment_ehr_purposes.length !== 0) {
        try {
            let visitTypeMatches = [];
            appointment_ehr_purposes.forEach(({ ehr_data }) => {
                const validVisitType = ehr_data.find(({ visibilities }) => {
                    return visibilities.consumer === Filters_1.DIRECT_BOOK;
                });
                if (validVisitType) {
                    visitTypeMatches.push(validVisitType.book_as_type_id);
                }
            });
            if (visitTypeMatches.length > 0) {
                // return the first one we found
                return visitTypeMatches[0];
            }
            else {
                // no matches
                return (0, exports.getDefaultVisitTypeFromConfig)(epicOSWConfig);
            }
        }
        catch (e) {
            // bad data
            return (0, exports.getDefaultVisitTypeFromConfig)(epicOSWConfig);
        }
    }
    else {
        // no appointment_ehr_purposes
        return (0, exports.getDefaultVisitTypeFromConfig)(epicOSWConfig);
    }
};
exports.getExtVisitTypeForProvider = getExtVisitTypeForProvider;
/**
 * Returns the default_visit_type_id from the epic_osw object
 * @param {Object} epicOSWConfig The epic_osw object from CS
 * @returns {String} The default_visit_type_id
 * @returns {String} Empty string if no default_visit_type_id found
 */
const getDefaultVisitTypeFromConfig = (epicOSWConfig) => {
    if (epicOSWConfig && epicOSWConfig.default_visit_type_id) {
        return epicOSWConfig.default_visit_type_id;
    }
    else {
        return '';
    }
};
exports.getDefaultVisitTypeFromConfig = getDefaultVisitTypeFromConfig;
//# sourceMappingURL=epicOSWUtils.js.map